import logo from "./logo.svg";
import "./App.css";
import MyLayout from "./components/MyLayout";
import { MainStore } from "./context/mainContext";
import { ThemeStore } from "./context/themeContext";

function App() {
  return (
    <div className="App">
      <ThemeStore>
        <MainStore>
          <MyLayout />
        </MainStore>
      </ThemeStore>
    </div>
  );
}

export default App;
